module.exports = __webpack_public_path__ + "static/bg-wedding-dcf72794196ccb76a354981a9a90053b.jpg";